import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ts1 from '../../images/testimonial/img-1.jpg'
import ts2 from '../../images/testimonial/img-2.jpg'
import ts3 from '../../images/testimonial/img-3.jpg'

import tright from '../../images/testimonial/r-img.jpg'


const Testimonial = (props) => {

    var settings = {
        dots: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
    };

    const testimonial = [
        {
            tsImg: ts1,
            Des: "“At Wilson Tamuka Attorneys, we commit to providing clear, ethical, and dependable legal guidance. Every client receives honest counsel, responsive communication, and solutions crafted with precision and integrity.”",
            Title: 'Our Commitment to Integrity',
            Sub: "WTA Built on Trust",
        },
        {
            tsImg: ts2,
            Des: "“We are dedicated to delivering excellence in every matter we handle. From commercial transactions to personal legal needs, our team approaches each case with diligence, strategy, and unwavering professionalism.”",
            Title: 'Our Commitment to Excellence',
            Sub: "WTA Excellence in Practice",
        },
        {
            tsImg: ts3,
            Des: "“Your peace of mind is our priority. We promise compassionate service, transparent processes, and a client-centered approach that ensures you feel protected, informed, and empowered at every step.”",
            Title: 'Our Commitment to Client Care',
            Sub: "WTA Service with Clarity & Compassion",
        }

    ]
    return (

        <section className={`wpo-testimonials-section-s2 section-padding ${props.tClass}`}>
            <div className="container">
                <div className="wpo-testimonials-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-12">
                            <div className="wpo-testimonials-active">
                                <Slider {...settings}>
                                    {testimonial.map((tesmnl, tsm) => (
                                        <div className="wpo-testimonials-item" key={tsm}>
                                            <p>{tesmnl.Des}</p>
                                            <div className="wpo-testimonial-info">
                                                <div className="wpo-testimonial-info-text">
                                                    <h5>{tesmnl.Title}</h5>
                                                    <span>{tesmnl.Sub}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <img src={tright} alt="" />
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Testimonial;